import React from 'react';

export default function ({ sideBarData, eleRef }) {
    return (
    <div>
    {eleRef.state.loggedin  && eleRef.state.isTryingToConceive && !eleRef.state.isMobile &&
      <section className="child_trying_to_concieve_right" >
         <div className="non_login_div_child">
           <div className="concieve_right_circle_div" onClick={()=>{this.openPopup()}}> 
               <a href="#">
               <img src="../../../../images/07-Trying-to-concieve.jpg" alt="Trying to Conceive" title="Trying to Conceive"/>
               </a>
            </div>
            <div className="B18_21 non_login_dnya"> Dnyaneshwari Deshmukh </div>
            <div className="B20_21 non_login_conce"> Trying to Conceive </div>
        </div>
      </section>
    }
    </div>
    )
}
